import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import VuexPersistence from 'vuex-persist';

import auth from './modules/auth';
import customer from './modules/customer';
import account from './modules/account';
import excel from './modules/excel';
import feedBack from './modules/feedBack';
import product from './modules/product';
import communication from './modules/communication';
import wallet from './modules/wallet';
import { CustomerStateInterface } from './modules/customer/types';
import { ProductStateInterface } from './modules/product/types';
import { AccountStateInterface } from './modules/account/types';
import { CompanyStateInterface } from './modules/company/types';
import company from './modules/company';
import { CommunicationStateInterface } from './modules/communication/types';
import { WalletStateInterface } from './modules/wallet/types';
import CookieStorage from '@/utils/cookieStorage';
export interface StatesForPersistence {
  customer: CustomerStateInterface;
  product: ProductStateInterface;
  account: AccountStateInterface;
  company: CompanyStateInterface;
  communication: CommunicationStateInterface;
  wallet: WalletStateInterface;
}

Vue.use(Vuex);


const vuexLocal = new VuexPersistence<StatesForPersistence>({
  storage: new CookieStorage(),
  key: `store-${ process.env.NODE_ENV }`,
  reducer: state => ({ 
    customer: state.customer, 
    product: state.product, 
    account: state.account, 
    company: state.company,
    communication: state.communication,
    wallet: state.wallet
   })
});

export default new Vuex.Store({
  modules: {
    auth,
    customer,
    account,
    excel,
    feedBack,
    product,
    company,
    communication,
    wallet
  },
  plugins: [vuexLocal.plugin]
});
